import { X } from 'lucide-react';
import { useState } from 'react';

interface GoalInputProps {
  value: string;
  onChange: (value: string) => void;
  onRemove?: () => void;
  placeholder?: string;
  maxLength?: number;
  autoFocus?: boolean;
}

export function GoalInput({
  value,
  onChange,
  onRemove,
  placeholder = 'Enter your goal...',
  maxLength = 200,
  autoFocus = false,
}: GoalInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const remaining = maxLength - value.length;

  return (
    <div className="relative">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder={placeholder}
        maxLength={maxLength}
        autoFocus={autoFocus}
        className={`textarea ${
          isFocused ? 'border-primary-500 ring-2 ring-primary-200' : ''
        } ${value.length >= maxLength ? 'border-accent-500' : ''}`}
        rows={3}
      />
      <div className="flex items-center justify-between mt-2">
        <span
          className={`text-xs ${
            remaining < 20 ? 'text-accent-600 font-semibold' : 'text-gray-500'
          }`}
        >
          {remaining} characters remaining
        </span>
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="text-gray-400 hover:text-error-600 transition-colors p-1"
            aria-label="Remove goal"
          >
            <X size={20} />
          </button>
        )}
      </div>
    </div>
  );
}
